"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleSpecialRefinementOnParams = void 0;
function handleSpecialRefinementOnParams(data) {
    if (data.refinement && data.refinement.substr(0, 1) === 'T') {
        data.tag = data.refinement;
        delete data.refinement;
        return data;
    }
    return data;
}
exports.handleSpecialRefinementOnParams = handleSpecialRefinementOnParams;
